import { retryGetAccessToken } from '@towns/privy'
import { env } from 'utils/environment'
import { Address } from 'viem'

export async function generateCoinbaseSessionToken(address: Address) {
    // Get Privy access token for authentication
    const accessToken = await retryGetAccessToken(3)

    // Call stackup-worker endpoint to generate session token
    const response = await fetch(`${env.VITE_AA_PAYMASTER_PROXY_URL}/api/onramp/coinbase-session`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${env.VITE_AUTH_WORKER_HEADER_SECRET}`,
            'X-PM-Token': accessToken ?? '',
        },
        body: JSON.stringify({
            walletAddress: address,
            assets: ['USDC'],
        }),
    })

    if (!response.ok) {
        let errorMessage = 'Failed to generate session token'
        try {
            const errorData = await response.json()
            errorMessage = errorData.message || errorMessage
        } catch {
            errorMessage = response.statusText || errorMessage
        }
        throw new Error(errorMessage)
    }

    const data = await response.json()
    if (!data.success || !data.data?.sessionToken) {
        throw new Error('Invalid response from session token endpoint')
    }

    return data.data.sessionToken
}
